<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        :formData="formData"
        :insuranceType="insuranceType"
        formID="get-offer-traffic-insurance"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <!-- <get-price-section :getPrice="getPrice" /> -->
      <Tables />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/component/navbar/Navbar"
import Header from "@/component/categories/Header"
import GetQuote from "@/component/categories/GetQuote"
import categoryInfo from "@/component/categories/CategoryInfo"
// import getPriceSection from '@/component/categories/GetPriceSection'
import Tables from "@/views/category-pages/compulsory-traffic-insurance/Tables"
import appContractedInsuranceCompanies from "@/component/contracted-insurance-companies/AppContractedInsuranceCompanies"
import frequentlyAskedQuestions from "@/component/expansional-question-panel/AppQuestionPanel"
import CompulsoryTrafficInsuranceData from "@/data/category-page-data/CompulsoryTrafficInsurance.js"
import Footer from "@/component/footer/Footer"
import QuotationType from "@/data/QuotationType"
import { filteredButtons } from "@/mixins/FilteredButtons"

export default {
  metaInfo: {
    title: "En Uygun Zorunlu Trafik Sigortası Teklifi Al",
    meta: [
      {
        name: "description",
        content:
          "Trafik sigortası sorgulama, trafik sigortası hesaplama işlemlerinizi online yapın. En uygun trafik sigortası fiyatlarını anında tek ekrandan karşılaştırın."
      }
    ]
  },
  mixins: [filteredButtons],
  name: "CompulsoryTrafficInsurance",
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    // getPriceSection,
    Tables,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data() {
    return {
      insuranceType: QuotationType.TRAFFIC,
      categoryInfo: CompulsoryTrafficInsuranceData.categoryInfo,
      getPrice: CompulsoryTrafficInsuranceData.getPrice,
      faqTitle: CompulsoryTrafficInsuranceData.faqTitle,
      faqTitleDesc: CompulsoryTrafficInsuranceData.faqTitleDesc,
      questions: CompulsoryTrafficInsuranceData.questions,
      formData: {
        description: {
          upperText: "Doğru Poliçe, Doğru Fiyat",
          title: "Zorunlu Trafik Sigortası",
          bottomText: "En Ucuz Trafik Sigortası Fiyatları"
        },
        button: "TRAFİK SİGORTASI TEKLİFLERİ AL",
        plate: true,
        fullname: true,
        identity: true,
        email: true,
        phone: true,
        document: true
      },
      quoteCard: {
        title: "Trafik Fiyatlarında Alokasko Avantajı",
        description:
          "En ucuz trafik sigortası fiyatlarını tek bir yerden karşılaştırın.",
        content: [
          {
            id: 1,
            icon: "fas fa-file-alt",
            title: "En İyi Trafik Kapsamı",
            desc:
              "Arabanızı korumaya yardımcı olacak en iyi teminatları seçin. Trafik kapsamınızı en doğru şekilde belirleyin."
          },
          {
            id: 2,
            icon: "fab fa-cc-visa",
            title: "20 Sigorta Şirketinden Fiyat",
            desc:
              "En ucuz trafik sigortası fiyatlarını karşılaştırmak için teklif alın. Trafik sigortası primlerinden tasarruf sağlayın"
          },
          {
            id: 3,
            icon: "fas fa-clipboard-check",
            title: "İndirimler",
            desc:
              "Trafik indirimlerine göz atarak araba sigortasından nasıl tasarruf sağlayacağınızı öğrenin. Taksit seçeneklerinden yararlanın."
          },
          {
            id: 4,
            icon: "fas fa-users-cog",
            title: "Uzman Desteği",
            desc:
              "Trafik sigortası söz konusu olduğunda, birçok seçeneğiniz var. Alokasko uzmanları, doğru kapsamı bulmanıza yardımcı olabilir.  En doğru teminatlarla en uygun fiyatları alabilmeniz için uzmanlarımız 7/24 yanınızdadır."
          }
        ]
      }
    }
  },
  mounted() {
    this.filterButtons("Trafik Sigortası")
  }
}
</script>
<style lang="scss">
@import "@/css/app.scss";
</style>
